// CalendarModalKopf.tsx — K6: die Kopfzeile des Kalender-Auswahlmodus.
// Nur im Fenster-Modus sichtbar, im `.cal-rd`-Scope, ohne Fluent-Komponenten.
// Auf dem Telefon sitzt sie als Sticky-Zeile über dem Tages-Selektor.

import React from "react";

export interface CalendarModalKopfProps {
    /** z. B. „Termin mit Vorgang VG-2026-0042 verknüpfen". */
    titel: string;
    /** Einzeiler darunter; ohne Angabe steht der Standard-Hinweis. */
    hinweis?: string;
    onFertig?: () => void;
}

/** Auch das Vollflächen-Overlay zeigt diesen Satz — der Hinweis darf nicht in
 *  zwei Hüllen auseinanderlaufen. */
export const STANDARD_HINWEIS =
    "Termin anklicken zum Verknüpfen — oder oben einen neuen Termin anlegen.";

export const CalendarModalKopf: React.FC<CalendarModalKopfProps> = ({
    titel,
    hinweis,
    onFertig,
}) => (
    <div className="cal-auswahl-kopf">
        <div className="cal-auswahl-titel">
            <strong>{titel}</strong>
            <span className="cal-auswahl-hinweis">{hinweis ?? STANDARD_HINWEIS}</span>
        </div>
        {onFertig && (
            <button type="button" className="cal-auswahl-fertig" onClick={onFertig}>
                Fertig
            </button>
        )}
    </div>
);

export default CalendarModalKopf;
